export default __webpack_public_path__ + "static/media/fourthMore.be1370e9.png";